import authAxios from "../utility/authAxios";
import { API_VERSION, SAAS_SERVICE_PATH } from "../config/axios";
import { setHttpParams } from "../utility/utils";

const API_URI = `${API_VERSION}/${SAAS_SERVICE_PATH}/bus-type`;

export const getAll = async (params = {}) => {
    params = setHttpParams(params);
    return authAxios.get(`${API_URI}?${params}`);
};

export const getBusType = async (id) => {
    return authAxios.get(`${API_URI}/${id}`);
};

export const createBusType = async (data) => {
    return authAxios.post(`${API_URI}`, data);
};

export const busTypeUpdate = async (id, data) => {
    return authAxios.put(`${API_URI}/${id}`, data);
};

export const deleteBusType = async (id) => {
    return authAxios.delete(`${API_URI}/${id}`);
};

export const getAllWithoutPaginate = async (params = {}) => {
    return authAxios.get(`${API_URI}/all`);
};
